import React, { useState } from "react";
import {
    FormControl,
    InputLabel,
    InputBase,
    FormHelperText,
    IconButton,
    InputAdornment
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { alpha, styled } from "@mui/material/styles";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
    'label + &': {
        marginTop: theme.spacing(2.5),
    },
    '& .MuiInputBase-input': {
        borderRadius: 4,
        position: 'relative',
        border: '1px solid',
        borderColor: theme.palette.mode === 'light' ? '#757575' : '#757575',
        fontSize: 16,
        padding: '10px 12px',
        paddingRight: '40px',
        transition: theme.transitions.create([
            'border-color',
            'background-color',
            'box-shadow',
        ]),
        '&:focus': {
            boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
    },
    '& .MuiInputAdornment-root': {
        position: "absolute",
        right: 8,
        top: "50%",
        transform: "translateY(-50%)",
        marginRight: "8px",
    }
}));

const Password = (props) => {
    const [showPassword, setShowPassword] = useState(false);
    const [localError, setLocalError] = useState(false);
    const [localErrorText, setLocalErrorText] = useState("");

    const handleChange = (event) => {
        const value = event.target.value;
        if (value === "") {
            setLocalError(true);
            setLocalErrorText("Enter password");
        } else {
            setLocalError(false);
            setLocalErrorText("");
        }

        if (props.onChange) {
            props.onChange(event);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };



    return (
        <FormControl variant="standard" fullWidth>
            <InputLabel shrink htmlFor={props.id}>
                {props.label}
            </InputLabel>
            <BootstrapInput
                type={showPassword ? "text" : "password"}
                fullWidth
                className={`TextField-Password ${props.classNameCustom}`}
                size={props.size}
                id={props.id}
                placeholder={props.placeholder}
                onChange={handleChange}
                value={props.value}
                name={props.name}
                disabled={props.disabled}
                required={props.required}
                autoComplete={props.autoComplete}
                endAdornment={(
                    <InputAdornment position="end">
                        <IconButton onClick={togglePasswordVisibility} edge="end">
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                )}
                error={props.error || localError}
            />
            {(props.errorText || localErrorText) && (
                <FormHelperText >
                    {props.errorText || localErrorText}
                </FormHelperText>
            )}
        </FormControl>
    );
};

export default Password;
